import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { Typography } from '@mui/material';
import { Inbox } from 'lucide-react';
import { OrderReferenceItem } from '@/types/order-type';
import { OrderReferenceRow } from './OrderReferenceRow';

export function OrderReferenceList({ items }: { items: OrderReferenceItem[] }) {
  return (
    <Card className="border border-slate-200 shadow-sm rounded-xl">
      <CardHeader className="py-3 px-3 sm:px-4 border-b border-slate-100">
        <Typography
          variant="subtitle2"
          sx={{
            fontWeight: 700,
            lineHeight: 1.2,
            fontSize: { xs: '0.9rem', sm: '1rem' },
            color: 'text.primary',
          }}
        >
          Source References
        </Typography>
      </CardHeader>

      <CardContent className="flex flex-col gap-1.5 p-2 sm:p-3 max-h-[400px] lg:max-h-[800px] overflow-y-auto">
        {(!items || items.length === 0) && (
          <div className="flex flex-col items-center gap-1.5 py-6 text-slate-400">
            <Inbox className="h-5 w-5" />
            <span className="text-xs">No references found.</span>
          </div>
        )}

        {items?.map((item) => (
          <OrderReferenceRow key={item.id} item={item} />
        ))}
      </CardContent>
    </Card>
  );
}
